export const FEMALE_TEST_QUESTION = [
  {
    id: 1,
    question:
      "忽然，您进入了一座大花园，院中百花盛开，您心中似有所动，想要折下一枝赏玩，您想要折下的是：",
    options: [
      { value: "A", label: "清香的红梅", attribute: "attribute3" },
      { value: "B", label: "嫩黄的迎春花", attribute: "attribute1" },
      { value: "C", label: "洁白的梨花", attribute: "attribute2" },
    ],
  },
  {
    id: 2,
    question: "忽然有一个声音传来，指责你折了院子里的花，此时您会？",
    options: [
      { value: "A", label: "好奇地询问对方是谁", attribute: "attribute1" },
      {
        value: "B",
        label: "感到很不好意思，准备诚惶诚恐地道歉",
        attribute: "attribute2",
        style: {
          width: "250px",
          height: "83px",
        },
      },
      { value: "C", label: "思考如何为自己辩解", attribute: "attribute3" },
    ],
  },
  {
    id: 3,
    question:
      "一阵烟雾过后，你面前出现了一个童子模样的人物，请问你看到的是什么形象的童子？",
    options: [
      { value: "A", label: "穿着青色袍子的", attribute: "attribute1" },
      {
        value: "B",
        label: "穿着红色箭袖的",
        attribute: "attribute3",
      },
      { value: "C", label: "穿着紫色坎肩的", attribute: "attribute2" },
    ],
  },
  {
    id: 4,
    question: "问明了您的身份后，童子邀请您跟着他在园中游玩，此时您会觉得？",
    options: [
      {
        value: "A",
        label: "（兴奋答应）好诶！",
        attribute: "attribute1",
        style: {
          width: "300px",
        },
      },
      {
        value: "B",
        label: "（有些紧张）哇，他要做什么，应该不会伤害我吧…",
        attribute: "attribute2",
        style: {
          width: "300px",
          height: "83px",
        },
      },
      {
        value: "C",
        label: "（警惕提防）唔，我要留神小心行事！",
        attribute: "attribute3",
        style: {
          width: "300px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 5,
    question:
      "一边走，童子一边和你介绍道，你误入了一处残破的旧戏台上幻化出的园林，而他则是昆曲之神座下的童儿，你心中充满疑惑，询问道：",
    options: [
      {
        value: "A",
        label: "昆曲之神？这是掌管什么的神明啊？",
        attribute: "attribute2",
        style: {
          width: "300px",
          height: "83px",
        },
      },
      {
        value: "B",
        label: "我是怎样会误入这里的呀？",
        attribute: "attribute3",
        style: {
          width: "300px",
        },
      },
      {
        value: "C",
        label: "所以这座幻化出的园林随时都会变化吗？",
        attribute: "attribute1",
        style: {
          width: "300px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 6,
    question: "童子微笑不语，却领着你走进了一个房间，此时你见到的场景是：",
    options: [
      {
        value: "A",
        label: "一间寂静的书斋，屋外是一株大柳树，一个小池塘里游着几只鸭子",
        attribute: "attribute1",
        style: {
          width: "330px",
          height: "83px",
        },
      },
      {
        value: "B",
        label: "碧纱糊窗的精致小阁，窗外隐隐透出亭台池馆，瓷瓶里插着杜鹃花",
        attribute: "attribute2",
        style: {
          width: "330px",
          height: "83px",
        },
      },
      {
        value: "C",
        label: "铺设着锦褥的房间显得昏暗，屋内点着蜡烛，焚香袅袅",
        attribute: "attribute3",
        style: {
          width: "330px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 7,
    question: "童子请你在这里为昆曲写些什么，留下纪念，你的反应是：",
    options: [
      {
        value: "A",
        label: "有些犹豫要不要答应，但实际已非常诚实地在思考要怎么写成一首诗",
        attribute: "attribute2",
        style: {
          width: "330px",
          height: "83px",
        },
      },
      {
        value: "B",
        label: "一笔一画非常认真地写下感想",
        attribute: "attribute3",
        style: {
          width: "330px",
        },
      },
      {
        value: "C",
        label: "不知道写什么耶...不如，我帮你画幅画怎么样！",
        attribute: "attribute1",
        style: {
          width: "330px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 8,
    question:
      "你正坐在桌前拿笔挥洒，忽然童子消失了，但他给你留下了信物，请问你收到的是：",
    options: [
      {
        value: "A",
        label: "一枝翠绿的柳枝",
        attribute: "attribute2",
      },
      {
        value: "B",
        label: "绣着兰花的手帕",
        attribute: "attribute1",
      },
      {
        value: "C",
        label: "银色朴素的凤钗",
        attribute: "attribute3",
      },
    ],
  },
];

export const MALE_TEST_QUESTION = [
  {
    id: 1,
    question:
      "不知不觉，您走入了一座大花园，忽然闻到一阵的芬芳香气，心中似有所动，您闻到的香气是：",
    options: [
      { value: "A", label: "清雅的白兰花香", attribute: "attribute2" },
      { value: "B", label: "露水湿润后的柏叶香", attribute: "attribute1" },
      { value: "C", label: "甜郁的含笑花香", attribute: "attribute3" },
    ],
  },
  {
    id: 2,
    question:
      "忽然远远有一个声音传来，似乎正在与您说话。这个声音略带有一些方言口音，请问您听到的是：",
    options: [
      { value: "A", label: "北京方言口音", attribute: "attribute1" },
      {
        value: "B",
        label: "扬州方言口音",
        attribute: "attribute3",
      },
      { value: "C", label: "苏州方言口音", attribute: "attribute2" },
    ],
  },
  {
    id: 3,
    question:
      "您连忙出声介绍自己，一阵烟雾过后，你面前出现了一个童子模样的人物，请问您此时看到的是什么形象的童子？",
    options: [
      { value: "A", label: "拿着拂尘的", attribute: "attribute1" },
      {
        value: "B",
        label: "拿着长剑的",
        attribute: "attribute2",
      },
      {
        value: "C",
        label: "拿着折扇的",
        attribute: "attribute3",
      },
    ],
  },
  {
    id: 4,
    question: "问明了您的身份后，童子邀请您跟着他在园中游玩，此时您会觉得？",
    options: [
      {
        value: "A",
        label: "（兴奋答应）好诶！那就麻烦小哥多和我做介绍了！",
        attribute: "attribute3",
        style: {
          width: "330px",
          height: "83px",
        },
      },
      {
        value: "B",
        label: "（警惕）看他这样说，应该不会伤害我，跟着他看看好了！",
        attribute: "attribute1",
        style: {
          width: "330px",
          height: "83px",
        },
      },
      {
        value: "C",
        label: "（沉吟）此地真是颇有一番玄机！",
        attribute: "attribute2",
        style: {
          width: "330px",
        },
      },
    ],
  },
  {
    id: 5,
    question:
      "一边走，童子一边和你介绍道，你误入了一处残破的旧戏台上幻化出的园林，而他则是昆曲之神座下的童儿，你心中充满疑惑，询问道：",
    options: [
      {
        value: "A",
        label: "昆曲？什么是昆曲啊？",
        attribute: "attribute3",
        style: {
          width: "290px",
        },
      },
      {
        value: "B",
        label: "我是怎样才会误入此地的？",
        attribute: "attribute1",
        style: {
          width: "290px",
        },
      },
      {
        value: "C",
        label: "所以这座幻化出园林随时都会变化吗？",
        attribute: "attribute2",
        style: {
          width: "290px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 6,
    question: "童子微笑不语，却领着你走进了一个房间，此时你见到的场景是：",
    options: [
      {
        value: "A",
        label: "一间修行的佛堂，墙上却悬挂着一把宝剑",
        attribute: "attribute2",
        style: {
          width: "300px",
          height: "83px",
        },
      },
      {
        value: "B",
        label: "陈设金碧辉煌的小厅，到处装饰以锦绣绫罗",
        attribute: "attribute1",
        style: {
          width: "300px",
          height: "83px",
        },
      },
      {
        value: "C",
        label: "非常朴素的屋子，书籍满架，桌面上凌乱摆着一些杂物",
        attribute: "attribute3",
        style: {
          width: "300px",
          height: "83px",
        },
      },
    ],
  },
  {
    id: 7,
    question: "那童子请你在这里为昆曲写些什么，留下纪念，你的反应是：",
    options: [
      {
        value: "A",
        label: "这有何难，写就是了！",
        attribute: "attribute2",
        style: {
          width: "300px",
        },
      },
      {
        value: "B",
        label: "这童子还挺有眼光，请我写点东西",
        attribute: "attribute1",
        style: {
          width: "300px",
          height: "83px",
        },
      },
      {
        value: "C",
        label: "倒要好好想想要怎么写才好！",
        attribute: "attribute3",
        style: {
          width: "300px",
        },
      },
    ],
  },
  {
    id: 8,
    question:
      "你正坐在桌前拿笔挥洒，忽然童子消失了，但他给你留下了信物，请问你收到的是：",
    options: [
      {
        value: "A",
        label: "一个装着珍珠的小木盒",
        attribute: "attribute1",
        style: {
          width: "280px",
        },
      },
      {
        value: "B",
        label: "一管美玉做的笛子",
        attribute: "attribute2",
        style: {
          width: "280px",
        },
      },
      {
        value: "C",
        label: "一把翠羽做的折扇",
        attribute: "attribute3",
        style: {
          width: "280px",
        },
      },
    ],
  },
];
